export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9440.86ed654e.jpg";